import { every, includes } from 'lodash/fp';

import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIsEveryUpsellRewardRestricted = ({ upsellApplicableRewards, restrictedUpsellRewards }) => {
  const isEveryRewardRestricted = uncapFpIterator(every)(
    // @ts-expect-error - Automatic, Please fix when editing this file
    (rewardIds, offerTypeId) =>
      every((rewardId) => includes(rewardId, restrictedUpsellRewards?.[offerTypeId]), rewardIds),
    upsellApplicableRewards,
  );
  return isEveryRewardRestricted;
};

export default getIsEveryUpsellRewardRestricted;
